import React from 'react';
import { Divider, Box, Typography } from '@mui/material';

export default function PageDividerText({ content, withOutLine }) {
  return (
    <Box display="flex" alignItems="center" sx={{ width: '100%', margin: 0 }} style={{marginBottom: 15}}>
      <Typography variant="body1" sx={{
        mr: 2,
        color: '#8b96c5',
        fontWeight: '600'
      }}>
        {content}
      </Typography>
      {(withOutLine === undefined && withOutLine !== true) && <Divider sx={{ flexGrow: 1, borderBottomWidth: 2, borderColor: 'rgba(222,222,222,255)' }} />}
    </Box>
  );
}
